import React from 'react';
import PropTypes from 'prop-types';

// Optimized SVGs
import OptimizedWordmarkBlack from '../../images/optimized-wordmark-black.svg';

/**
 * Performance-optimized logo components with:
 * - Explicit width/height attributes to prevent layout shift
 * - High priority loading for above-the-fold content
 * - Synchronous decoding for faster rendering
 * - Optimized SVGs with reduced file sizes
 */

const LogoWordmarkBlackOptimized = ({ className, alt, priority = true, ...props }) => {
  const containerClass = className || 'max-w-xs';
  const altText = alt || 'Abler Nordic Logo';
  
  return (
    <div className={containerClass} {...props}>
      <img
        src={OptimizedWordmarkBlack}
        className="w-full h-auto"
        alt={altText}
        width="1425"
        height="193"
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        decoding="sync"
        style={{
          maxWidth: '100%',
          height: 'auto',
          aspectRatio: '1425 / 193'
        }}
      />
    </div>
  );
};

LogoWordmarkBlackOptimized.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
  priority: PropTypes.bool,
};

export {
  LogoWordmarkBlackOptimized,
};